import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../shared/api.service';

@Injectable({
  providedIn: 'root'
})
export class DeliveryPlatformService {

  constructor(private api: ApiService) { }

  public getShopsRelatedBrands(): Observable<any> {
    return this.api.get(`/api/v1/admin/delivery-platform/get-active-brands`, 'delivery')
  }

  public uploadMenu(data: any): Observable<any> {
    const formData = new FormData();
    formData.append('file', data);
    formData.append('delivery_platform[]', "UBER_EATS");
    var rtn = this.api.postfileUpload('/api/v1/remote/upload-menu', formData, `delivery`)
    return rtn;

  }

  public syncWithMasterMenuCreate(id: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/remote/sync-with-master-menu/${id}`, `delivery`)
    return rtn;
  }

  public syncWithMasterMenu(id: any, batch: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/remote/sync-with-master-menu/${id}?batch_id=${batch}`, `delivery`)
    return rtn;
  }

  public getAllPlatforms(): Observable<any> {
    var rtn = this.api.get(`/api/v1/admin/platform`, `delivery`)
    return rtn;
  }

  public getDeliveryPlatforms(): Observable<any> {
    var rtn = this.api.get(`/api/v1/admin/delivery-platform`, `delivery`)
    return rtn;
  }

  public getPlatformsForShops(id: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/admin/delivery-platform?shop=${id}&status=Active`, `delivery`)
    return rtn;
  }

  public getDpPosData(): Observable<any> {
    var rtn = this.api.get(`/api/v1/get-dp-pos-data`, `delivery`)
    return rtn;
  }

  public getPlatform(id: Number): Observable<any> {
    var rtn = this.api.get(`/api/v1/admin/delivery-platform/${id}`, `delivery`)
    return rtn;
  }

  public uploadMenuForPlatform(files: any, dps: any, outlets, master_outlet): Observable<any> {
    const formData = new FormData();
    for (let i = 0; i < dps.length; i++) {
      formData.append('platforms[' + i + ']', dps[i]);
    }
    for (let i = 0; i < files.length; i++) {
      if (files[i]) {
        formData.append('file_' + files[i].platformId, files[i].file);
      }
    }
    for (let i = 0; i < outlets.length; i++) {
      formData.append('outlets[' + i + ']', outlets[i]);
    }
    var rtn = this.api.postfileUpload('/api/v1/setup-menu', formData, `delivery`)
    return rtn;

  }

  public getAvailability(): Observable<any> {
    var rtn = this.api.get('/api/v1/admin/delivery-platform', `delivery`)
    return rtn;
  }


  public fetchMenu(data: any): Observable<any> {
    var rtn = this.api.post('/api/v1/remote/fetch-menu', data, `delivery`)
    return rtn;
  }

  public syncMenu(data: any): Observable<any> {
    var rtn = this.api.post('/api/v1/remote/sync-pos-items-with-delivery-platform', data, `delivery`)
    return rtn;
  }

  public getLogsForMenu(id: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/admin/get-log-list?main_menu=${id}`, `delivery`)
    return rtn;
  }

  public getRevisionsForMenu(id: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/admin/menu-history/${id}`, `delivery`)
    return rtn;
  }

  public deployRevision(id: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/admin/menu-history/deploy/${id}`, `delivery`)
    return rtn;
  }

  public getPlatforms(): Observable<any> {
    var rtn = this.api.get('/api/v1/admin/platform', `delivery`)
    return rtn;
  }

  public updatePlatform(id, data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/admin/delivery-platform/` + id, data, `delivery`)
    return rtn;
  }

  public addPlatform(data: any): Observable<any> {
    var rtn = this.api.post('/api/v1/admin/delivery-platform', data, `delivery`)
    return rtn;
  }

  public getIntegrations(franchise: any, shop: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/admin/delivery-platform?franchise=${franchise}&shop=${shop}`, `delivery`)
    return rtn;
  }

  public getAllIntegrations(franchise: any, shop: any, keyword): Observable<any> {
    var rtn = this.api.get(`/api/v1/admin/delivery-platform/get_integration?franchise=${franchise}&shop=${shop}&q=${keyword}`, `delivery`)
    return rtn;
  }

  public getMoreIntegrations(franchise: any, shop: any, nextUrl): Observable<any> {
    var rtn = this.api.get(`/api/v1/admin/delivery-platform/get_integration?page=${nextUrl}&franchise=${franchise}&shop=${shop}`, `delivery`)
    return rtn;
  }

  public updateAutoAcceptingAndAccepting(id, data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/admin/delivery-platform/order_action_update/` + id, data, `delivery`)
    return rtn;
  }

  public updateAutoAccepting(id, data: any): Observable<any> {
    console.log(id, data, ' data')
    var rtn = this.api.put(`/api/v1/auto-accept/status/` + id, { "status": data }, `delivery`)
    return rtn;
  }

  public getOrderActions(franchise: any, shop: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/admin/delivery-platform/get_order_actions?franchise=${franchise}&shop=${shop}`, `delivery`)
    return rtn;
  }

  public deleteIntegration(id: Number): Observable<any> {
    var rtn = this.api.delete(`/api/v1/admin/delivery-platform/${id}`, `delivery`)
    return rtn;
  }

  public getMasters(): Observable<any> {
    var rtn = this.api.get(`/api/v1/admin/delivery-platform?master=1`, `delivery`)
    return rtn;
  }

  public createDpCredentials(data): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/admin/delivery-platform-credentials`, data, `delivery`)
    return rtn;
  }

  public updateDpCredentials(id: any, data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/admin/delivery-platform-credentials/${id}`, data, `delivery`)
    return rtn;
  }

  public getDpCredentials(id: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/admin/delivery-platform-credentials/delivery_platform/${id}`, `delivery`)
    return rtn;
  }

  public updateOwnDriverStatus(id, data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/admin/delivery-platform/own_driver_update/${id}`, data, `delivery`)
    return rtn;
  }

  public createPaymentKey(data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/order-service/payment/key`, data, `delivery`)
    return rtn;
  }

  public getAllOrders(franchise: any, shop: any): Observable<any> {
    var data = this.api.get(`/api/v1/admin/orders/status?franchise=${franchise}&shop=${shop}`, `delivery`)
    return data;
  }

  public getOrdersPagination(franchise: any, shop: any, status, nextUrl, keyword): Observable<any> {
    var data = this.api.get(`/api/v1/admin/orders/status` + (status == 'ALL' ? '' : '/' + status) + `?page=${nextUrl}&franchise=${franchise}&shop=${shop}&query=${keyword}`, `delivery`)
    return data;
  }

  public getOrderByStatus(status: string, franchise: any, shop: any): Observable<any> {
    var data = this.api.get(`/api/v1/admin/orders/status/` + status + `?franchise=${franchise}&shop=${shop}`, `delivery`)
    return data;
  }

  public searchOrders(franchise: any, shop: any, keyword: any, nextUrl: any): Observable<any> {
    var data = this.api.get(`/api/v1/admin/orders/search?query=${keyword}&franchise=${franchise}&shop=${shop}&page=${nextUrl}`, `delivery`)
    return data;
  }

  public respondToOrder(action: string, id: string): Observable<any> {
    var url = '';
    var reason = [];
    if (action == 'Accept') {
      url = '/api/v1/accept-order/' + id;
      reason = ['accepted'];
    } else if (action == 'Reject') {
      url = '/api/v1/deny-order/' + id;
      reason = ["RESTAURANT_TOO_BUSY"];
    } else if (action == 'Ready') {
      url = '/api/v1/ready-to-pickup/' + id;
      reason = ['ready'];
    } else if (action == 'Complete') {
      url = '/api/v1/complete-order/' + id;
      reason = ['complete'];
    } else {
      url = '/api/v1/cancel-order/' + id;
      reason = ["RESTAURANT_TOO_BUSY"];
    }
    var data = this.api.post(url, reason, `delivery`)
    return data;
  }

  public placeTestOrder(data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/place-test-order`, data, `delivery`)
    return rtn;
  }

  public updateOrderPrepTime(id, data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/admin/delivery-platform/order-prep-time-update/${id}`, data, `delivery`)
    return rtn;
  }

  public updateOrderReadyTime(id: string, data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/update-ready-time/${id}`, data, `delivery`)
    return rtn;
  }

}
